module.exports = __webpack_public_path__ + "1b5eefbbf8516b28a2cdfe13a2e84bad.svg";